import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=094394a4&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094394a4')) {
      api.createRecord('094394a4', component.options)
    } else {
      api.reload('094394a4', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=094394a4&", function () {
      api.rerender('094394a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2caR9Div76bWR/JS/comp/ImgFallback2.vue"
export default component.exports